<template>
    <!-- BOTTONI PRIMA DELLA MAPPA -->


    <div id="map-container">
        <h1>Human Perception</h1>

        <div class="d-flex flex-wrap justify-content-center my-4 gap-3">
            <button class="btn btn-outline-primary" type="button">
                <a href="/human_perception/report">⚠️ Fai segnalazione</a>
            </button>
        </div>

        <div v-if="mapUrl">
            <iframe :src="mapUrl" width="100%" height="600px" allowfullscreen></iframe>
        </div>
    </div>

    <div class="table-container">
        <div v-if="loading" class="loading">
            <div class="loading-text">
                Caricamento...
            </div>
            <p class="spinner-border text-dark" role="status">
                <span class="visually-hidden">Loading...</span>
            </p>
        </div>
        <div v-else-if="df_finale_dict && columns">
            <div v-if="Object.keys(df_finale_dict).length && columns.length" class="table-category">
                <DataTable class="table table-bordered table-hover table-responsive pois-table" :options="options">
                    <thead>
                    <tr>
                        <th v-for="key in columns" :key="key">
                            {{ key }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in df_finale_dict" :key="data">
                        <td v-for="key in columns" :key="key" :class="{
                                    'security-level': key === 'Livello di sicurezza'}">
                            {{ data[key] }}
                        </td>
                    </tr>
                    </tbody>
                </DataTable>
            </div>
            <p v-else>Non ci sono dati disponibili.</p>
        </div>
        <p v-else>Non ci sono dati disponibili.</p>
    </div>

    <hr>
</template>


<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-select';
import {useHead} from "@vueuse/head";

DataTable.use(DataTablesCore);

export default {
    components: {DataTable},
    setup() {
        useHead({
            title: 'InfoNav - Human Perception'
        });
    },
    data() {
        return {
            loading: false,
            mapUrl: null,
            df_finale_dict: null,
            columns: [],
            options: {
                responsive: true,
                select: false,
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.1/i18n/it-IT.json'
                },
                drawCallback: function () {
                    const security_level_td = document.getElementsByClassName("security-level");
                    for (let i = 0; i < security_level_td.length; i++) {
                        let inner_text = security_level_td[i].innerText.trim();
                        if (inner_text == "ALTO") {
                            security_level_td[i].classList.add('security-high');
                        } else if (inner_text == "MEDIO") {
                            security_level_td[i].classList.add('security-medium');
                        } else if (inner_text == "BASSO") {
                            security_level_td[i].classList.add('security-low');
                        }
                    }
                }
            }
        }
    },
    methods: {
        async getData() {
            this.loading = true;

            try {
                const response = await fetch(`/api/human_perception/`, {
                    method: 'GET',
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();

                await this.$nextTick();
                this.df_finale_dict = data['df_finale_dict'];
                this.columns = data['columns'];
                this.mapUrl = data['map_url'];
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.getData();
    }

}
</script>


<style scoped>
body {
    display: flex;
    flex-direction: column;
    font-family: "Poppins", sans-serif !important;
    font-size: large !important;
}

ul {
    display: flex;
    justify-content: space-evenly;
    padding-left: 0%;
    margin: 0;
    width: -webkit-fill-available;
}

li {
    list-style: none;
    width: -webkit-fill-available;
    text-align: center;
}

li.nav-item:hover {
    background-color: #b7defb;
    border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: white !important;
}

a {
    margin-left: auto;
    text-decoration: none !important;
}

#key p {
    margin: 0;
    margin-left: 1%;
    margin-right: 1%;
    margin-top: 1%;
}

#key h4 {
    margin: 0;
    margin-top: 1%;
}


#color-way {
    height: 22px;
    width: 22px;
}

#n-accident p {
    font-size: smaller;
}

html,
body {
    margin: 0;
    padding: 0;
}

@media (max-height: 40em) {
    h1 {
        font-size: 1.5em;
    }
}

.security-high {
    background-color: lightgreen !important;
}

.security-medium {
    background-color: yellow !important;
}

.security-low {
    background-color: lightcoral !important;
}


#scores {
    width: 100%;
    display: flex;
    border: 1px solid;
}

/* Header */
.header {
    background-color: #0000FF;
    color: white;
    padding: 20px;
    text-align: center;
    margin-bottom: 20px;
}

.green-column {
    background-color: #96adff !important;
}

.table-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.table-category {
    margin-bottom: 40px;
}

.table-category h3 {
    text-align: center;
    margin-bottom: 15px;
    color: #007bff;
}

.table th,
.table td {
    text-align: center;
    vertical-align: middle;
}

.table thead th {
    background-color: #007bff;
    color: white;
    font-weight: bold;
}

.legend-container {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin: 30px auto;
}

.legend-container h3 {
    text-align: center;
    color: #007bff;
    margin-bottom: 20px;
}

#map-container {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
}

#map-container h1 {
    text-align: center;
    margin-bottom: 20px;
    color: #007bff;
}

.pollutant-info {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.pollutant-info span {
    display: inline-block;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-text {
    margin-bottom: 1rem;
}

.year-selector-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
}

.year-selector-container h2 {
    margin-bottom: 15px;
}

#year-selector {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>